// @flow
import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { User } from '../../types'
import { createAlert, updateAlert } from '../../actions/user'
import AlertForm from '../AlertForm'

type Props = {
  user: User,
  alert?: Object,
  isOpen: boolean,
  initialValues: Object,
  createAlert: Function,
  updateAlert: Function,
  onRequestClose: Function
}

class AlertFormModal extends Component {
  props: Props

  handleSubmit = (data) => {
    if (this.props.alert) {
      this.props
        .updateAlert(this.props.user.id, this.props.alert.id, data)
        .then(this.props.onRequestClose)
    } else {
      this.props
        .createAlert(this.props.user.id, data)
        .then(this.props.onRequestClose)
    }
  }

  render() {
    const { isOpen, onRequestClose, initialValues } = this.props
    if (!isOpen) return null

    return (
      <Modal
        isOpen={isOpen}
        className="modal"
        contentLabel="Alert form"
        overlayClassName="modal-overlay"
        onRequestClose={onRequestClose}
      >
        <AlertForm
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          onRequestClose={onRequestClose}
        />
      </Modal>
    )
  }
}

export default connect(
  null,
  { createAlert, updateAlert }
)(AlertFormModal)



// WEBPACK FOOTER //
// ./src/components/AlertFormModal/index.js